import React, { PureComponent } from 'react';
import { Tabs, Tab } from '@mui/material';

import RobotStatus from './RobotStatus';
import { isMobile } from 'react-device-detect';
import { UITab } from './helpers/task';
import { SampleBox } from '../db';

// Tabs container sizing — fills the row to the right of the menu icon (58px).
const tabsRootSx = {
  minHeight: '40px',
  height: '40px',
  width: 'calc(100% - 58px)',
} as const;

// Per-tab sizing — fixed 300px on desktop, fluid on mobile.
const tabRootSx = {
  width: isMobile ? undefined : '300px',
  minHeight: '40px',
  height: '40px',
} as const;

interface AppBarTabsProps {
  sessionActive: boolean;
  currentTab: UITab;
  onChange: (event: React.ChangeEvent<{}>, value: any) => void;
  availableTabs: string[];
  connectionStatus: string;
}

const boxesTabLabel = () => {
  let out = 'Boxes';

  const currentBox = SampleBox.getCurrentBox();

  if (!currentBox) {
    return out;
  }

  const currentBoxSamplesNumber = currentBox.getSamplesNumber();
  out += ` - <b>${currentBox.short_uid}(${currentBoxSamplesNumber})</b>`;

  return out;
};

class AppBarTabs extends PureComponent<AppBarTabsProps> {
  render() {
    return (
      <div style={{ display: 'flex' }}>
        <div id="menudrawer-container-1" style={{ display: 'inline-flex' }}></div>
        {this.props.availableTabs.length > 0 && this.props.sessionActive && (
          <Tabs
            indicatorColor="primary"
            textColor="primary"
            variant={isMobile ? 'scrollable' : 'fullWidth'}
            value={this.props.currentTab}
            onChange={this.props.onChange}
            sx={tabsRootSx}
          >
            {this.props.availableTabs.includes('mission') && (
              <Tab value="mission" label="Mission" data-testid="tab-mission" sx={tabRootSx} key={'mission'} />
            )}
            {this.props.availableTabs.includes('schedule') && (
              <Tab value="schedule" label={'Schedule'} data-testid="tab-schedule" sx={tabRootSx} />
            )}
            <Tab value="map" label="Map" data-testid="tab-map" sx={tabRootSx} />
            {/* // TODO comment this section out to remove the box history tab */}
            {this.props.availableTabs.includes('boxes') && (
              <Tab
                value="boxes"
                label={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: boxesTabLabel(),
                    }}
                  />
                }
                sx={tabRootSx}
              />
            )}
            {this.props.availableTabs.includes('robot') && (
              <Tab
                value="robot"
                label={<RobotStatus connectionStatus={this.props.connectionStatus} />}
                sx={tabRootSx}
              />
            )}
          </Tabs>
        )}
      </div>
    );
  }
}

export default AppBarTabs;
